export default __webpack_public_path__ + "static/media/heroBg.cb5d2cd4.jpg";